// intl.js
import { createIntl } from 'react-intl';
import messagesEn from './locales/en/messages';
import messagesFr from './locales/fr/messages';
import messagesEs from './locales/es/messages';
import messagesCn from './locales/cn/messages';
import messagesAr from './locales/ar/messages';
import messagesDe from './locales/de/messages';
import messagesHi from './locales/hi/messages';
import messagesId from './locales/id/messages';
import messagesIt from './locales/it/messages';
import messagesJa from './locales/ja/messages';
import messagesKo from './locales/ko/messages';
import messagesPt from './locales/pt/messages';
import messagesRu from './locales/ru/messages';

const locales = {
  en: messagesEn,
  fr: messagesFr,
  es: messagesEs,
  ru:messagesRu,
  pt:messagesPt,
  ko:messagesKo,
  ja:messagesJa,
  it:messagesIt,
  id:messagesId,
  hi:messagesHi,
  de:messagesDe,
  ar:messagesAr,
  cn:messagesCn
};

const defaultLocale = 'en';
const currentLocale = defaultLocale;

const intl = createIntl({ locale: currentLocale, messages: locales[currentLocale] });

export { intl, locales, defaultLocale, currentLocale };
